// 保留原有规格标签切换，便于已有按钮继续调用。
function showContent(contentId) {
  document.querySelectorAll('.spec-content').forEach(content => {
    content.classList.remove('active');
  });
  document.querySelectorAll('#custom-navigation button').forEach(button => {
    button.classList.remove('active');
  });
  const content = document.getElementById(contentId);
  const button = document.querySelector(`#custom-navigation button[onclick*="${contentId}"]`);
  if (content) content.classList.add('active');
  if (button) button.classList.add('active');
}

function initSpecVideoCarousels(root = document) {
  root.querySelectorAll('[data-spec-video-carousel]:not([data-carousel-ready])').forEach(carousel => {
    const track = carousel.querySelector('[data-video-track]');
    const previousButton = carousel.querySelector('[data-video-prev]');
    const nextButton = carousel.querySelector('[data-video-next]');
    const dotsContainer = carousel.querySelector('[data-video-dots]');
    if (!track || !previousButton || !nextButton || !dotsContainer) return;

    const templates = Array.from(track.querySelectorAll('template[data-spec-video-template]'));
    const deferred = templates.length > 0;
    const mediaElements = deferred
      ? templates.flatMap(template => Array.from(template.content.querySelectorAll('video, iframe, img')))
      : Array.from(track.querySelectorAll('video, iframe, img'));

    carousel.setAttribute('data-carousel-ready', 'true');
    if (!mediaElements.length) {
      carousel.hidden = true;
      return;
    }

    function prepareMedia(media) {
      // 保留原有轮播尺寸规则；视频仍使用浏览器播放控件。
      media.removeAttribute('width');
      media.removeAttribute('height');
      if (media.tagName === 'VIDEO') {
        media.controls = true;
        media.preload = 'metadata';
      }
    }

    const slides = mediaElements.map((media, index) => {
      const slide = document.createElement('div');
      slide.className = 'spec-video-slide';
      slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      if (deferred) {
        // 各媒体保持在独立template中，未选中时不会触发真实地址请求。
        const holder = document.createElement('template');
        holder.setAttribute('data-spec-video-holder', '');
        holder.content.appendChild(media);
        slide.appendChild(holder);
      } else {
        prepareMedia(media);
        slide.appendChild(media);
      }
      return slide;
    });
    track.replaceChildren(...slides);

    let currentIndex = 0;
    let nearViewport = !deferred;
    dotsContainer.replaceChildren();
    const dots = slides.map((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'spec-video-dot';
      dot.setAttribute('aria-label', `Go to video ${index + 1}`);
      dot.addEventListener('click', () => {
        currentIndex = index;
        updateCarousel();
      });
      dotsContainer.appendChild(dot);
      return dot;
    });

    function loadCurrent() {
      if (!deferred || !nearViewport) return;
      const slide = slides[currentIndex];
      const holder = slide.querySelector('template[data-spec-video-holder]');
      if (holder) {
        const media = holder.content.querySelector('video, iframe, img');
        if (media) prepareMedia(media);
        // 此时才将当前媒体插入活动文档，保留原地址、静音和自动播放设置。
        slide.appendChild(holder.content);
        holder.remove();
      }
      slide.querySelectorAll('video[autoplay]').forEach(video => {
        if (video.paused) video.play().catch(() => {});
      });
    }

    function updateCarousel() {
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      slides.forEach((slide, index) => {
        const selected = index === currentIndex;
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        if (!selected || (deferred && !nearViewport)) {
          slide.querySelectorAll('video').forEach(video => video.pause());
        }
        dots[index].classList.toggle('is-active', selected);
      });
      loadCurrent();
    }

    previousButton.addEventListener('click', () => {
      currentIndex = (currentIndex + slides.length - 1) % slides.length;
      updateCarousel();
    });
    nextButton.addEventListener('click', () => {
      currentIndex = (currentIndex + 1) % slides.length;
      updateCarousel();
    });
    if (slides.length <= 1) {
      previousButton.hidden = true;
      nextButton.hidden = true;
      dotsContainer.hidden = true;
    }
    updateCarousel();

    if (deferred) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          nearViewport = entries[0].isIntersecting;
          updateCarousel();
        }, {rootMargin: '600px 0px'});
        observer.observe(carousel);
      } else {
        // 较旧浏览器按模块实际位置检查，避免完全无法加载视频。
        const checkPosition = () => {
          const box = carousel.getBoundingClientRect();
          nearViewport = box.width > 0 && box.height > 0 && box.bottom >= -600 && box.top <= window.innerHeight + 600;
          updateCarousel();
        };
        window.addEventListener('scroll', checkPosition, {passive: true});
        window.addEventListener('resize', checkPosition);
        carousel.addEventListener('click', checkPosition);
        document.querySelectorAll('#custom-navigation button').forEach(button => {
          button.addEventListener('click', checkPosition);
        });
        checkPosition();
      }
    }
  });
}

// 兼容首次加载、脚本较晚执行，以及主题编辑器重新加载分区。
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initSpecVideoCarousels());
} else {
  initSpecVideoCarousels();
}
document.addEventListener('shopify:section:load', event => initSpecVideoCarousels(event.target));


/* 产品资料与使用指南统一在新标签页打开 */
;(function () {
  function updateDocumentLinks() {
    document.querySelectorAll(
      '#custom-document .document-a a[href], #custom-document .document-g a[href]'
    ).forEach(function (link) {
      link.target = '_blank';
      link.relList.add('noopener');
    });
  }

  /* 兼容脚本在页面加载前后执行 */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateDocumentLinks, { once: true });
  } else {
    updateDocumentLinks();
  }
})();